import { ReactNode, Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { useRecruitmentFeature } from 'src/hooks/useRecruitmentFeature';

const Status404 = lazy(() => import('src/content/pages/Status/Status404'));

/**
 * Renders children only when the tenant's recruitment feature flag is on.
 * Loading shows the standard loader (no flash of the feature page); disabled
 * or errored shows the app's normal 404 page.
 */
function RecruitmentFeatureGate({ children }: { children: ReactNode }) {
  const { enabled, isLoading } = useRecruitmentFeature();
  if (isLoading) return <SuspenseLoader />;
  if (!enabled) {
    return (
      <Suspense fallback={<SuspenseLoader />}>
        <Status404 />
      </Suspense>
    );
  }
  return <>{children}</>;
}

export default RecruitmentFeatureGate;
